import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./root-reducer";
import storage from "redux-persist/lib/storage/session";
import { persistReducer, persistStore } from "redux-persist";
import hardSet from "redux-persist/lib/stateReconciler/hardSet";

//import { setupListeners } from "@reduxjs/toolkit/query";

const persistConfig = {
  key: "root",
  storage,
  // `hcbbResultView` holds how far into each result list the member has
  // scrolled, and `hcbbAdvancedFilters` the advanced-search criteria and
  // panel open state. The rows and options both describe live in the React
  // Query cache, which is deliberately not persisted (see
  // `shouldDehydrateQuery` in main.tsx), so persisting either would leave
  // them pointing at data that no longer exists — a restored depth of five
  // batches would fire five requests on the next load, and a restored
  // `isPanelOpen: true` would pop the panel open over an empty page.
  blacklist: ["csrChat", "hcbbResultView", "hcbbAdvancedFilters"],
  // transforms: [
  //   encryptTransform({
  //     secretKey: SEC_KEY,
  //     onError: function (error: Error) {
  //       console.error("Encryption error:", error);
  //     },
  //   }),
  // ],
  stateReconciler: hardSet,
  devTools: true,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

//avoids from changing/deleting from local/session storage
window.addEventListener("storage", function (e) {
  if (e.key) {
    sessionStorage.setItem(e.key, e.oldValue || "");
  }
});

export type RootState = ReturnType<typeof rootReducer>;
// export type AppDispatch = typeof store.dispatch;

export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const presistor = persistStore(store);
